// source: app/grpc/v1/stream.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.app.grpc.v1.STREAM_STATE', null, global);
/**
 * @enum {number}
 */
proto.app.grpc.v1.STREAM_STATE = {
  STREAM_UNKNOWN: 0,
  STREAM_WAITING: 1,
  STREAM_LOCAL_DATA: 2,
  STREAM_ACCEPTED: 3,
  STREAM_LOADING: 4,
  STREAM_LIVE_STREAM: 5,
  STREAM_CLOSED: 6,
  STREAM_DEMO: 7
};

goog.object.extend(exports, proto.app.grpc.v1);
